/**
 * SMSStatsHeader - Header with SMS statistics
 */
import { Calendar } from 'lucide-react';

export default function SMSStatsHeader({ stats, deliveryStats, scheduledCount }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h2 className="font-heading text-2xl text-foreground">SMS Management</h2>
        <p className="text-muted-foreground">Send SMS messages to your customers</p>
      </div>
      
      <div className="flex gap-4">
        <div className="bg-card rounded-xl p-4 text-center min-w-[100px]">
          <p className="text-2xl font-bold text-primary">{stats.today_sent}</p>
          <p className="text-xs text-muted-foreground">Today</p>
        </div>
        <div className="bg-card rounded-xl p-4 text-center min-w-[100px]">
          <p className="text-2xl font-bold text-foreground">{stats.month_sent}</p>
          <p className="text-xs text-muted-foreground">This Month</p>
        </div>
        <div className="bg-card rounded-xl p-4 text-center min-w-[100px]">
          <p className="text-2xl font-bold text-green-500">{deliveryStats.delivered}</p>
          <p className="text-xs text-muted-foreground">Delivered</p>
        </div>
        <div className="bg-card rounded-xl p-4 text-center min-w-[100px]">
          <p className="text-2xl font-bold text-amber-500">{scheduledCount}</p>
          <p className="text-xs text-muted-foreground">Scheduled</p>
        </div>
      </div>
    </div>
  );
}
